// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3jlks","name":"Header_name__3tRVd","birthday":"Header_birthday__P7QJM","skeleton":"Header_skeleton__2FmYs"};